import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "c-cu-tab" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "tab__body" }

interface ITab {
  label: string;
  value: string | number;
}

interface ITabs {
  tabs: ITab[];
  modelValue: string | number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomTab',
  props: {
    tabs: {},
    modelValue: { default: 0 }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emit = __emit

const change = (tab: ITab) => {
  emit('update:modelValue', tab.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["tab", tab.value == __props.modelValue ? 'active' : '']),
        key: index,
        onClick: ($event: any) => (change(tab))
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(tab.label), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})